import { combineReducers } from '@reduxjs/toolkit';
import cattegory from './cattegory';
import segment from './segment';
import store from './store';

const root = combineReducers({
  cattegory,
  store,
  segment,
});

export default root;
